import { User } from '../types';

/**
 * Whether the logged-in user may use HotQuus (#29).
 * Uses Quu login profile fields when present; admins always allowed.
 */
export function userHasHotQuuAccess(user: User | null | undefined): boolean {
  if (!user) return false;

  const role = String(user.userRole ?? '').toLowerCase();
  if (role.includes('admin')) return true;

  const adminRights = String(user.adminRights ?? '').toLowerCase();
  if (adminRights === 'true' || adminRights === '1' || adminRights.includes('admin')) return true;

  // Quu2Go login returns the HotQuus permission here, e.g. blastRights: "Hot Quus".
  const blastRights = String(user.blastRights ?? '').toLowerCase();
  if (blastRights.includes('hot quu') || blastRights.includes('hotquu')) return true;

  const combined = [user.rtRights, user.rights, user.jumpGateRights, user.blastRights]
    .filter((v) => v != null && String(v).trim() !== '')
    .map((v) => String(v).toLowerCase())
    .join(' ');

  if (!combined) return true;

  const hasEmergencyBlast =
    combined.includes('emergency') || combined.includes('blast') || combined.includes('emb');
  const hasHotQuu = combined.includes('hotquu') || combined.includes('hot quu');

  if (combined.includes('nohotquu') || combined.includes('no hot quu')) return false;

  return hasEmergencyBlast && hasHotQuu;
}

export const HOTQUU_ACCESS_DENIED_MESSAGE =
  'Your account does not have HotQuus access. Contact your administrator.';
